import React from 'react';
import Icon from './UI/Icon';
import './About.css';

const qualificationsList = [
  { term: 'BPT', desc: 'Bachelor of Physiotherapy' },
  { term: 'MIAP', desc: 'Member of Indian Association of Physiotherapists' },
  { term: 'CMT', desc: 'Certified Manual Therapist' },
  { term: 'NDT', desc: 'Neuro-Developmental Treatment' },
  { term: 'MFR', desc: 'Myofascial Release Specialist' },
  { term: 'D.Ph', desc: 'Diploma in Pharmacy' }
];

const About = () => {
  return (
    <section id="about" className="section bg-soft">
      {/* Visual background pattern */}
      <div className="about-bg-decoration"></div>

      <div className="container">
        <div className="grid-2 about-grid">
          
          {/* Left Column: Professional Spotlight Portrait */}
          <div className="about-visual animate-fade-in-up">
            <div className="spotlight-wrapper">
              <div className="spotlight-glow"></div>
              <div className="spotlight-frame glass-card">
                <img 
                  src="/assets/doctor_profile.jpg" 
                  alt="Dr. ANIL KUMAR (PT) - Consultant Physiotherapist" 
                  className="spotlight-image"
                />
                
                {/* Doctor Title Banner inside Frame */}
                <div className="spotlight-banner">
                  <h3>Dr. ANIL KUMAR (PT)</h3>
                  <p>Consultant Physiotherapist</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Detailed Medical Credentials & Core Practice Values */}
          <div className="about-content animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            <span className="section-tag">Clinical Leadership</span>
            <h2 className="section-title">Meet Your Physiotherapist</h2>
            
            <p className="about-lead">
              With <strong>12+ years of professional experience</strong> in clinical physiotherapy, orthopedics, neurology, and sports medicine, Dr. Anil Kumar (PT) is dedicated to restoring your health and vitality.
            </p>

            <p className="about-body">
              At Active Joint Clinic, we go beyond routine therapy. Our approach is purely personalized and holistic—customized to help you restore joint mobility, speed up recovery, and regain your confidence so you can get back to doing what you love.
            </p>

            {/* Qualifications / Badges Grid */}
            <div className="qualifications-box">
              <h4>Degrees & Certifications:</h4>
              <div className="qualifications-grid">
                {qualificationsList.map((qual, idx) => (
                  <div key={idx} className="qual-card glass-card">
                    <div className="qual-badge-icon">
                      <Icon name="graduationcap" size={16} />
                    </div>
                    <div className="qual-info">
                      <span className="qual-term">{qual.term}</span>
                      <span className="qual-desc">{qual.desc}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Clinic Values list */}
            <div className="about-values">
              <div className="value-item">
                <Icon name="checkcircle" size={18} className="value-icon" />
                <span>Customized home exercise programs to accelerate recovery</span>
              </div>
              <div className="value-item">
                <Icon name="checkcircle" size={18} className="value-icon" />
                <span>Affordable, patient-friendly care in a welcoming clinic</span>
              </div>
              <div className="value-item">
                <Icon name="checkcircle" size={18} className="value-icon" />
                <span>Holistic solutions designed specifically for all age groups</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
